import { MSFabricbootstrap } from '@idmc-ms-fabric/integration';

import initializeUI from './initialize.ui';
import initializeWorker from './initialize.worker';

MSFabricbootstrap({
	initializeUI,
	initializeWorker,
});
